export default "__VITE_ASSET__DJRs2_aJ__"